import { t } from "i18next";

import { Box, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import FAQList from "@/src/components/organisms/FAQList/FAQList";

import {
  homePageFAQListAccordionDetailsTextSx,
  homePageFAQListOuterSx,
  homePageFAQListSectionSx,
  homePageFAQReadMoreButtonSx
} from "@/src/pages/consumer/HomePage/components/HomePageFAQList/homePageFAQList.styles";
import {
  HOMEPAGE_INNER_GAP,
  HOMEPAGE_SECTION_TITLE_SX
} from "@/src/pages/consumer/HomePage/homePage.constants";

export const HomePageFAQList = () => {
  return (
    <Box sx={homePageFAQListOuterSx}>
      <Box sx={homePageFAQListSectionSx} id="HomePageFAQContainer">
        <Typography
          variant="h2"
          sx={{ ...HOMEPAGE_SECTION_TITLE_SX, mb: 1, pl: 1 }}
        >
          {t("consumer.homePage.faqTitle")}
        </Typography>
        <Typography
          variant="h3"
          sx={{ ...HOMEPAGE_SECTION_TITLE_SX, mb: HOMEPAGE_INNER_GAP, pl: 1 }}
        >
          {t("consumer.homePage.faqBody")}
        </Typography>

        <Box sx={{ fontWeight: theme.typography.fontWeightBold }}>
          <FAQList
            readMoreButtonSx={homePageFAQReadMoreButtonSx}
            accordionDetailsTextSx={homePageFAQListAccordionDetailsTextSx}
          />
        </Box>
      </Box>
    </Box>
  );
};
